import TextField from "@mui/material/TextField";
import React, { FC, useCallback, useState } from "react";
import FieldLabel from "shared/components/Form/components/FieldLabel";
import { InputHookResult } from "shared/hooks/useInputState";
import { BORDER, COLOR_BLACK, COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import EmptyOptions from "./components/EmptyOptions";
import {
  CustomMenuStyles,
  StyledAutocomplete,
  StyledOption,
  StyledOptionText,
} from "./styled";

type OptionType = {
  id: string;
  name: string;
};

type Props = {
  value: OptionType | null;
  onChange: (
    event: React.SyntheticEvent<Element, Event>,
    value: OptionType | null,
  ) => void;
  id: string;
  placeholder: string;
  inputProps?: InputHookResult;
  options: OptionType[];
  onSubmitTagType: () => void;
  loading: boolean;
};

export const TagTypeField: FC<Props> = ({
  value,
  options,
  inputProps,
  onChange,
  id,
  placeholder,
  onSubmitTagType,
  loading,
}) => {
  const inputValue = inputProps?.input.value;
  const [menuOpen, setMenuOpen] = useState(false);

  const handleOpenMenu = useCallback(() => setMenuOpen(!menuOpen), [menuOpen]);

  const handleEmptyOptionClick = () => {
    onSubmitTagType();
    setMenuOpen(false);
  };

  return (
    <StyledAutocomplete
      id={id}
      value={value}
      isOpened={menuOpen}
      options={options}
      disableCloseOnSelect
      onChange={(event, newValue) => {
        onChange(event, newValue);
        handleOpenMenu();
      }}
      onBlur={() => setMenuOpen(false)}
      open={menuOpen}
      inputValue={inputValue}
      onInputChange={(_e, newInputValue, reason) => {
        if (reason === "input") setMenuOpen(true);
        inputProps?.setValue(newInputValue);
      }}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) =>
        option && value ? option.id === value.id : false
      }
      renderOption={(props, option, { selected }) => {
        return (
          <StyledOption
            {...props}
            key={option.id}
            data-testid={`option-${selected}`}
          >
            <StyledOptionText color={COLOR_BLACK} variant="bodyMRegular">
              {option.name}
            </StyledOptionText>
          </StyledOption>
        );
      }}
      renderInput={(params) => (
        <>
          <FieldLabel label="Primary Tag *" labelColor={COLOR_BLACK} />
          <TextField
            {...params}
            placeholder={placeholder}
            onClick={handleOpenMenu}
          />
        </>
      )}
      ListboxProps={{
        sx: {
          padding: 0,
          borderTop: `${BORDER(2, COLOR_PRIMARY_MAIN)}`,
        },
      }}
      slotProps={{
        paper: {
          sx: CustomMenuStyles,
        },
      }}
      noOptionsText={
        <EmptyOptions
          loading={loading}
          inputValue={inputValue}
          onClick={handleEmptyOptionClick}
        />
      }
    />
  );
};
